import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-safetyguidelines',
  templateUrl: './safetyguidelines.page.html',
  styleUrls: ['./safetyguidelines.page.scss'],
})
export class SafetyguidelinesPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }
  dismiss() {
    this.modalCtrl.dismiss();
  }
}
